import { useCallback, useEffect, useState } from 'react';
import { getResumeInfo, getNewUniprofileResume } from 'api/uniprofileResume';
import uniprofileResumeStore from 'store/UniprofileResume';
import channelProviderStore from 'store/ChannelApplicationProvider';
import { UniprofileFormData } from 'types/provider';
import { transferProviderToFormData } from 'utils/channel';
import useSetPercentages from './useSetPercentages';
import useSetNewPercentages from './useSetNewPercentages';
import useProviderServiceFlag from 'hooks/useProviderServiceFlag';
import { INewUniprofileResume } from 'types/newUniprofile';

const useGetUniprofileResumeInfo = (documentId?: string): [UniprofileFormData | INewUniprofileResume | undefined, boolean | null, string, (id?: string) => void] => {
    const [, setResumeInfo] = uniprofileResumeStore.useStore();
    const [, setProvider] = channelProviderStore.useStore();
    const [data, setData] = useState<UniprofileFormData | INewUniprofileResume>();
    const [, flagLoading, refetchFlag] = useProviderServiceFlag();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [setPercentage] = useSetPercentages();
    const [setNewPercentage] = useSetNewPercentages();
    // const [flag, setFlag] = useState<boolean>();
    // const isKlarity = !!flag?.klarityServiceFlag;

    const fetchData = async (id?: string) => {
        setLoading(true);
        try {
            const res = await getResumeInfo({
                documentId: id,
            });

            if (res && !res.error) {
                const resultData = transferProviderToFormData(res.data?.data);

                setResumeInfo('data', resultData);
                setProvider('data', resultData!);
                setData(resultData);
                setPercentage(resultData);
            } else {
                setError(res.error);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const fetchNewUniprofileResume = async (id?: string) => {
        setLoading(true);
        try {
            const res = await getNewUniprofileResume({
                documentId: id,
            });

            if (res && !res.error) {
                const resultData: INewUniprofileResume = res.data?.data;
                setData(resultData);
                setResumeInfo('data', resultData);
                setNewPercentage(resultData);
            } else {
                setError(res.error);
            }
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    };

    const fetchFn = async (id?: string) => {
        const flagRes = await refetchFlag();

        if (flagRes?.klarityServiceFlag) {
            await fetchData(id);
        } else {
            await fetchNewUniprofileResume(id);
        }
    };

    useEffect(() => {
        if (documentId) {
            fetchFn(documentId);
        }
    }, [documentId, fetchFn]);

    return [data, loading, error, fetchFn];
};

export default useGetUniprofileResumeInfo;
